// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Env = require("../../../../reason/common/Env.bs.js");
let React = require("react");
let Stripe = require("../../../../reason/stripe/Stripe.bs.js");
let ButtonsV5 = require("../../../../v5/common/Components/ButtonsV5.bs.js");
let Responsive = require("../../helpers/Responsive.bs.js");
let Form__TextInput = require("../../../../v5/common/Components/Form__TextInput.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let Stripe__Components = require("../../atoms/Stripe/Stripe__Components.bs.js");
let InlineWarning__Jsx3 = require("../../atoms/InlineWarning/InlineWarning__Jsx3.bs.js");
let Colors = require("uikit/styles/colors");

let amex = (require('../../../../../assets/images/amex.svg'));

let discover = (require('../../../../../assets/images/discover.svg'));

let mastercard = (require('../../../../../assets/images/mastercard.svg'));

let visa = (require('../../../../../assets/images/visa.svg'));

function PaymentForm__Jsx3$CCImage(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("img", {
      style: {
        backgroundImage: "linear-gradient(180deg, #FFFFFF 0%, #EAEAEA 100%)",
        border: "1px solid " + Colors.gallery,
        borderRadius: "4px",
        overflow: "hidden"
      },
      src: props.src
    }),
    className: "w-[60px] sm:w-[66px]"
  });
}

let CCImage = {
  amex: amex,
  discover: discover,
  mastercard: mastercard,
  visa: visa,
  make: PaymentForm__Jsx3$CCImage
};

function PaymentForm__Jsx3$FormWithoutElements(props) {
  let onToken = props.onToken;
  let stripe = Stripe.React.useStripe();
  let elements = Stripe.React.useElements();
  let match = React.useReducer((state, action) => {
    switch (action.TAG) {
      case "SetName" :
        return {
          name: action._0,
          cardNumberValid: state.cardNumberValid,
          cardExpiryValid: state.cardExpiryValid,
          cardCVCValid: state.cardCVCValid,
          status: state.status
        };
      case "SetCardNumberValidation" :
        return {
          name: state.name,
          cardNumberValid: action._0,
          cardExpiryValid: state.cardExpiryValid,
          cardCVCValid: state.cardCVCValid,
          status: state.status
        };
      case "SetCardExpiryValidation" :
        return {
          name: state.name,
          cardNumberValid: state.cardNumberValid,
          cardExpiryValid: action._0,
          cardCVCValid: state.cardCVCValid,
          status: state.status
        };
      case "SetCardCVCValidation" :
        return {
          name: state.name,
          cardNumberValid: state.cardNumberValid,
          cardExpiryValid: state.cardExpiryValid,
          cardCVCValid: action._0,
          status: state.status
        };
      case "SetStatus" :
        return {
          name: state.name,
          cardNumberValid: state.cardNumberValid,
          cardExpiryValid: state.cardExpiryValid,
          cardCVCValid: state.cardCVCValid,
          status: action._0
        };
    }
  }, {
    name: "",
    cardNumberValid: false,
    cardExpiryValid: false,
    cardCVCValid: false,
    status: "NotAsked"
  });
  let dispatch = match[1];
  let state = match[0];
  let onCardNumberValidationChange = React.useCallback(isValid => dispatch({
    TAG: "SetCardNumberValidation",
    _0: isValid
  }), [dispatch]);
  let onCardExpiryValidationChange = React.useCallback(isValid => dispatch({
    TAG: "SetCardExpiryValidation",
    _0: isValid
  }), [dispatch]);
  let onCardCVCValidationChange = React.useCallback(isValid => dispatch({
    TAG: "SetCardCVCValidation",
    _0: isValid
  }), [dispatch]);
  let handleSubmit = e => {
    e.preventDefault();
    if (elements === undefined) {
      return;
    }
    if (stripe === undefined) {
      return;
    }
    let card = Stripe.React.Elements.getCardElement(Primitive_option.valFromOption(elements), "cardNumber");
    dispatch({
      TAG: "SetStatus",
      _0: "Loading"
    });
    Stripe.API.createToken(Primitive_option.valFromOption(stripe), card, {
      name: state.name
    }).then(x => {
      if (x.TAG === "Ok") {
        return onToken(x._0).then(status => dispatch({
          TAG: "SetStatus",
          _0: status
        }));
      }
      let error_1 = x._0.message;
      let error = {
        NAME: "CreateTokenError",
        VAL: error_1
      };
      return Promise.resolve(dispatch({
        TAG: "SetStatus",
        _0: error
      }));
    });
  };
  let match$1 = state.status;
  let tmp;
  if (typeof match$1 === "object") {
    let variant = match$1.NAME;
    tmp = variant === "CreateTokenError" || variant === "Error" || variant === "PaymentError" ? JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(InlineWarning__Jsx3.make, {
          children: JsxRuntime.jsx(JsxRuntime.Fragment, {
            children: match$1.VAL
          })
        }),
        className: "mb-4"
      }) : null;
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("form", {
      children: [
        tmp,
        JsxRuntime.jsx("h6", {
          children: "Accepted payment types",
          className: "font-semibold text-gray-700 mb-2"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(PaymentForm__Jsx3$CCImage, {
              src: visa
            }),
            JsxRuntime.jsx(PaymentForm__Jsx3$CCImage, {
              src: mastercard
            }),
            JsxRuntime.jsx(PaymentForm__Jsx3$CCImage, {
              src: amex
            }),
            JsxRuntime.jsx(PaymentForm__Jsx3$CCImage, {
              src: discover
            })
          ],
          className: "flex justify-between items-center mb-4 gap-1 md:gap-2"
        }),
        JsxRuntime.jsx(Stripe__Components.CardNumberElement.make, {
          placeholder: "0000 0000 0000 0000",
          labelText: "Card number",
          onValidationChange: onCardNumberValidationChange
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Stripe__Components.CardExpiryElement.make, {
                labelText: "Expiration date",
                onValidationChange: onCardExpiryValidationChange
              }),
              className: "w-[47%]"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Stripe__Components.CardCVCElement.make, {
                labelText: "Security code",
                onValidationChange: onCardCVCValidationChange
              }),
              className: "w-[47%]"
            })
          ],
          className: "my-4 flex flex-row justify-between"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Form__TextInput.make, {
            labelText: "Name on Card",
            placeholderText: "John Smith",
            onChange: e => dispatch({
              TAG: "SetName",
              _0: e.target.value
            }),
            value: state.name
          }),
          className: "mb-8"
        }),
        JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
          disabled: !(state.cardNumberValid && state.cardExpiryValid && state.cardCVCValid && state.name !== "") || state.status === "Loading",
          size: "huge",
          className: "w-full",
          children: JsxRuntime.jsx("div", {
            children: props.buttonText,
            className: "flex justify-center"
          })
        })
      ],
      onSubmit: handleSubmit
    })
  });
}

let FormWithoutElements = {
  make: PaymentForm__Jsx3$FormWithoutElements
};

let stripe = Stripe.loadStripe(Env.stripe_key);

function PaymentForm__Jsx3$Form(props) {
  return JsxRuntime.jsx(Stripe.React.Elements.make, {
    stripe: stripe,
    children: JsxRuntime.jsx(PaymentForm__Jsx3$FormWithoutElements, {
      buttonText: props.buttonText,
      onToken: props.onToken
    })
  });
}

let Form = {
  make: PaymentForm__Jsx3$Form
};

let Heading;

let responsive = Responsive.make;

let View;

let InlineWarning;

exports.Heading = Heading;
exports.responsive = responsive;
exports.View = View;
exports.InlineWarning = InlineWarning;
exports.CCImage = CCImage;
exports.FormWithoutElements = FormWithoutElements;
exports.stripe = stripe;
exports.Form = Form;
/* amex Not a pure module */
